import { MultiRangeSlider } from "PFComponents/slider/multirange_slider";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PreferencesFormValues } from "../edit_preferences_modal";
import css from "../edit_preferences_modal.module.scss";

export const RoleDuration = (): JSX.Element => {
  const { t } = useTranslation("marketplace", { keyPrefix: "editPreferencesModal" });

  const { control } = useFormContext<PreferencesFormValues>();

  return (
    <div className={css.duration}>
      <Controller
        name="projectDurationMonths"
        control={control}
        render={({ field }) => (
          <MultiRangeSlider
            title={t("roleDuration")}
            min={1}
            max={24}
            value={field.value}
            onChange={field.onChange}
            getValueLabel={(count) => t("months", { count })}
          />
        )}
      />
    </div>
  );
};
